import NumberUtil from '../../../services/NumberUtil'

export default class PeriodeMonitoringVNBDto {

  constructor(json) {
    if (json) {
      this.json = json
      this.vnbName = json.vnbName

      this.kontingent = json.kontingent
      this.verbrauch = json.verbrauch
      this.verbrauchProzent = json.verbrauchProzent ? NumberUtil.percent(json.verbrauchProzent) + ` %` : ''

      this.ueberschrittene = json.ueberschrittene
      this.vfTotal = json.vfTotal
      this.vfZugestellt = json.vfZugestellt

    } else {
      this.json = {}
    }
  }

  get verfuegungen() {
    return `${this.vfZugestellt} / ${this.vfTotal}`
  }

  get vnb() {
    return this.vnbName
  }

}
